/* global axios */
import ApiClient from './ApiClient';

class MeetingsAPI extends ApiClient {
  constructor() {
    super('meetings', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(meetingId) {
    return axios.get(`${this.url}/${meetingId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(meetingId, data) {
    return axios.patch(`${this.url}/${meetingId}`, data);
  }

  destroy(meetingId) {
    return axios.delete(`${this.url}/${meetingId}`);
  }

  bulkUpdate(ids, data) {
    return axios.patch(`${this.url}/bulk_update`, { ids, ...data });
  }

  listComments(meetingId) {
    return axios.get(`${this.url}/${meetingId}/meeting_comments`);
  }

  createComment(meetingId, content) {
    return axios.post(`${this.url}/${meetingId}/meeting_comments`, { content });
  }

  updateComment(meetingId, commentId, payload) {
    return axios.patch(
      `${this.url}/${meetingId}/meeting_comments/${commentId}`,
      payload
    );
  }

  destroyComment(meetingId, commentId) {
    return axios.delete(
      `${this.url}/${meetingId}/meeting_comments/${commentId}`
    );
  }

  listActivities(meetingId) {
    return axios.get(`${this.url}/${meetingId}/meeting_activities`);
  }
}

export default new MeetingsAPI();
